import React from 'react';

import { cn } from 'domain/core';
import { InputProps } from './common-types';
import { commonInputClassName } from './Common';

export const Input = React.forwardRef((props: InputProps, ref: any) => {
	const { className, ...rest } = props;

	return (
		<input
			className={cn(
				'input',
				commonInputClassName,
				'rounded border border-neutral-300',
				'text-neutral-600',
				'focus:border-primary-300 focus:ring-1 focus:ring-primary-300 focus:ring-offset-0',
				className
			)}
			{...rest}
			ref={ref}
		/>
	);
});

Input.displayName = 'Input';

export const Checkbox = React.forwardRef((props: InputProps, ref: any) => {
	const { className, type, ...rest } = props;

	return (
		<input
			className={cn(
				'checkbox',
				'appearance-none overflow-hidden',
				'h-4 w-4',
				'cursor-pointer',
				'rounded border border-primary-700',
				'transition-colors duration-150',
				"after:relative after:-top-[6px] after:text-sm after:font-extrabold after:text-neutral-100 after:content-['✓']",
				'hover:ring-1 hover:ring-primary-400 hover:ring-opacity-30 hover:ring-offset-0',
				'focus:outline-none focus:ring-2 focus:ring-primary-400 focus:ring-opacity-60 focus:ring-offset-0',
				'checked:bg-primary-700',
				className
			)}
			type='checkbox'
			{...rest}
			ref={ref}
		/>
	);
});

Checkbox.displayName = 'Checkbox';

export const Date = React.forwardRef<
	HTMLInputElement,
	{
		date: string;
		setDate: any;
	}
>(({ date, setDate }, ref) => {
	return (
		<input
			ref={ref}
			type='date'
			className={'max-w-[10rem] rounded border border-neutral-200 px-2 text-xs'}
			value={date}
			onChange={(e) => setDate(e.target.value)}
		/>
	);
});

Date.displayName = 'Date';

export const Radio = React.forwardRef((props: InputProps, ref: any) => {
	const { className, type, ...rest } = props;

	return (
		<input
			className={cn(
				'radio',
				'overflow-hidden',
				'h-4 w-4',
				'cursor-pointer',
				className
			)}
			type='radio'
			ref={ref}
			{...rest}
		/>
	);
});

Radio.displayName = 'Radio';
